// extracted by mini-css-extract-plugin
export var accordion = "styles-module--accordion--d8efb";
export var accordionButton = "styles-module--accordion-button--9a580";
export var accordionContainer = "styles-module--accordion-container--88deb";
export var isOpen = "styles-module--is-open--231bd";
export var withCustomTitle = "styles-module--with-custom-title--ec56a";